import React from 'react';
import Icon from '../../../components/AppIcon';

const SystemStatusCard = ({ title, status, value, unit, alert = false, details = [] }) => {
  const getStatusColor = () => {
    if (alert) return 'text-error';
    if (status === 'healthy') return 'text-success';
    if (status === 'warning') return 'text-warning';
    return 'text-muted-foreground';
  };

  const getStatusIcon = () => {
    if (alert) return 'AlertTriangle';
    if (status === 'healthy') return 'CheckCircle';
    if (status === 'warning') return 'AlertCircle';
    return 'Circle';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center justify-between mb-3">
        <h4 className="text-sm font-medium text-foreground">{title}</h4>
        <div className={`flex items-center space-x-1 ${getStatusColor()}`}>
          <Icon name={getStatusIcon()} size={14} />
          <span className="text-xs capitalize">{status}</span>
        </div>
      </div>
      <div className="space-y-2">
        <div className="text-lg font-semibold text-foreground">
          {value} <span className="text-sm text-muted-foreground">{unit}</span>
        </div>
        
        {details?.length > 0 && (
          <div className="space-y-1">
            {details?.map((detail, index) => (
              <div key={index} className="flex justify-between text-xs">
                <span className="text-muted-foreground">{detail?.label}</span>
                <span className="text-foreground">{detail?.value}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SystemStatusCard;